var map = {
	"./file.js": 266,
	"./image_file.js": 267
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 164;



//////////////////
// WEBPACK FOOTER
// ./commit nonrecursive ^\.\/.*\.(js|es6)$
// module id = 164
// module chunks = 0